import React from 'react';

import * as t from './useLinkPortal.types';

export const useLinkPortal = (): t.LinkPortalController => {
  const [portalData, setPortalData] = React.useState<t.PortalData>(null);

  return { portalData, setPortalData };
};
